import { Observable } from 'rxjs';

/**
 * Implemented by a side sheet body that needs to stop the sheet closing — an editor with unsaved
 * changes, a save in flight.
 *
 * Polarity: TRUE means "safe to close". This is the OPPOSITE of the app's own guard in
 * clinic-setup-modal.component.ts, which closes on `!confirmed` — do not copy that one.
 */
export interface SideSheetCloseGuard {
  canCloseSideSheet(): Observable<boolean>;
}

/**
 * Duck-typed rather than a base class: single inheritance would lock out bodies that already
 * extend something, and an Angular 8 base class needing DI must itself be decorated. Bodies still
 * write `implements SideSheetCloseGuard`, so a misspelled method is a compile error at the body.
 */
export function isSideSheetCloseGuard(bodyInstance: any): bodyInstance is SideSheetCloseGuard {
  return !!bodyInstance && typeof bodyInstance.canCloseSideSheet === 'function';
}
